// extracted by mini-css-extract-plugin
module.exports = {"container":"DescriptionLinks_container__Nm8kh"};